import * as React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'

import BenchmarkBannerSection from 'src/components/organisms/BenchmarkBannerSection'
interface Props {
  children: React.ReactNode
  background?: string
  fullHeight?: boolean
  showBenchmark?: boolean
}

const Hero = ({
  background,
  children,
  fullHeight = false,
  showBenchmark = false,
}: Props) => (
  <>
    <Box
      sx={{
        height: {md: fullHeight ? '100vh' : 'auto', xs: 'auto'},
        pb: fullHeight || showBenchmark ? 0 : 20,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundImage: `url(${background})`,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          height: {md: '60vh', xs: 'auto'},
          display: 'flex',
        }}
      >
        <Grid container spacing={3} sx={{mt: {md: 30, xs: 20}}}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: '50%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Box sx={{pr: {md: 3, xs: 0}, pb: {md: 0, xs: 10}}}>{children}</Box>
          </Grid>
        </Grid>
      </Container>
      {showBenchmark && <BenchmarkBannerSection />}
    </Box>
  </>
)

export default Hero
